<template>
  <section class="content_section extra-features">
    <div class="ef-header">
      <h1 class="ef-title">{{ (options.Lang && options.Lang.ExtraFeatures) || 'Extra Features' }}</h1>
      <SegmentedTabs v-model="activeFeature" :tabs="featureTabs" />
    </div>

    <div class="ef-panel">
      <p v-if="!featureTabs.length" class="ef-empty">
        {{ (options.Lang && options.Lang.extraFeaturesNone) || 'No extra features are enabled.' }}
      </p>
      <CheckoutFeatureTab v-if="checkoutEnabled" v-show="activeFeature === 'checkout'" :options="options" />
      <!-- Future feature panels: <FooFeatureTab v-show="activeFeature === 'foo'" :options="options" /> -->
    </div>
  </section>
</template>

<script>
import CheckoutFeatureTab from '../../components/extraFeatures/CheckoutFeatureTab.vue'
import SegmentedTabs from '../../components/parts/SegmentedTabs.vue'

export default {
  name: 'ExtraFeatures',
  components: { CheckoutFeatureTab, SegmentedTabs },
  props: {
    options: { type: Object, required: true }
  },
  data() {
    return {
      activeFeature: null
    };
  },
  computed: {
    checkoutEnabled() { return !!this.options.ModulInvoiceCheckout; },
    // Only tabs whose underlying module is enabled. Add future features here gated
    // on their own module flag.
    featureTabs() {
      const L = this.options.Lang || {};
      const tabs = [];
      if (this.checkoutEnabled) tabs.push({ value: 'checkout', label: L.feature_checkout || 'Checkout', icon: 'shopping_cart' });
      return tabs;
    }
  },
  watch: {
    // Keep the active tab on an available one (or none).
    featureTabs: {
      immediate: true,
      handler(tabs) {
        if (!tabs.find(t => t.value === this.activeFeature)) {
          this.activeFeature = tabs.length ? tabs[0].value : null;
        }
      }
    }
  }
};
</script>

<style scoped>
.extra-features { padding: 0 1.5rem 2rem; }
.ef-header {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: wrap;
  padding: 0 20px;
  margin-bottom: 1.5rem;
}
.ef-title { font-size: 30px; margin: 0; color: #2c2c2c; }
.ef-panel { padding: 0 8px; }
.ef-empty { font-style: italic; color: #999; padding: 1.5rem 20px; }
</style>
